import React from "react";
import { CalendarDays } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

const TABLE_HEAD = [
  { id: "event", label: "Event" },
  { id: "details", label: "Details" },
  { id: "when", label: "When" },
  { id: "status", label: "Status" },
  { id: "action", label: "" },
];

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ eventsData, onEditRow, searching, }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!eventsData?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: CalendarDays,
            title: "No events yet",
            text: "Upcoming events you publish show on your website automatically.",
          }
    }
  >
    {eventsData?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow} />
    ))}
  </DataTable>
);

export default TableView;
